import EmailFooterV2 from '../components/FooterV2';

interface EmailProps {
  instructorName: string
  courseName: string
  courseDate: string
  courseDuration: string
  courseId: string
  session: string
  time: string
  participantCount: number
  companyName: string
  checkoutDeadline?: string
  checkoutLink: string
  supportEmail?: string
  supportPhone?: string
  managerName?: string
  managerEmail?: string
}

export default function InstructorCheckoutReminderEmail({
  instructorName = "Ana Carolina Soares",
  courseName = "Fundamentos de Data Analytics",
  courseDate = "15 de abril de 2025",
  courseDuration = "120 minutos",
  courseId = "FA-2025-001",
  session = "1ª aula",
  time = "06:00 às 14:00",
  participantCount = 12,
  companyName = "Empresa XYZ Ltda",
  checkoutDeadline = "16 de abril de 2025 às 18:00",
  checkoutLink = "https://trivium.com.br/instructor/checkout/FA-2025-001",
  supportEmail = "suporte@trivium.com.br",
  supportPhone = "(11) 3181-5940",
  managerName = "Carlos Silva",
  managerEmail = "carlos.silva@trivium.com.br",
}: EmailProps) {
  return (
    <div style={{ margin: 0, padding: 0, fontFamily: "Arial, sans-serif", backgroundColor: "#ffffff" }}>
      {/* Responsive CSS Styles */}
      <style dangerouslySetInnerHTML={{
        __html: `
          @media only screen and (max-width: 600px) {
            .email-container { width: 100% !important; max-width: 100% !important; border-radius: 0 !important; }
            .body-content { padding: 24px 20px !important; }
            .header { padding: 16px !important; }
            .logo { width: 100px !important; }
            .title { font-size: 20px !important; margin: 12px 0 4px !important; }
            .subtitle { font-size: 14px !important; margin: 0 0 20px !important; }
            .badge { font-size: 12px !important; padding: 6px 12px !important; }
            .card { padding: 12px !important; margin-bottom: 6px !important; }
            .card-label { font-size: 11px !important; }
            .card-value { font-size: 14px !important; }
            .section-title { font-size: 16px !important; margin: 20px 0 8px !important; }
            .info-box { padding: 16px !important; }
            .info-box h3 { font-size: 15px !important; }
            .info-box p { font-size: 13px !important; }
            .info-list { font-size: 13px !important; }
            .btn { display: block !important; width: 100% !important; text-align: center !important; margin-bottom: 8px !important; }
            .btn-primary { padding: 14px 16px !important; font-size: 15px !important; }
            .list, .warning-list { font-size: 13px !important; padding-left: 16px !important; }
            .contact-box { padding: 16px !important; }
            .contact-title { font-size: 15px !important; }
            .contact-info { font-size: 13px !important; }
            .footer { padding: 20px 16px !important; }
            .footer-logo { width: 70px !important; }
            .social-icons { justify-content: center !important; gap: 20px !important; }
            .social-icon { width: 24px !important; height: 24px !important; }
            .urgent-highlight { padding: 12px !important; }
            .checkout-cta { padding: 16px !important; }
          }
          @media only screen and (max-width: 480px) {
            .body-content { padding: 20px 16px !important; }
            .title { font-size: 18px !important; }
            .subtitle { font-size: 13px !important; }
            .card { padding: 10px !important; }
            .card-label { font-size: 10px !important; }
            .card-value { font-size: 13px !important; }
            .section-title { font-size: 15px !important; }
            .info-box { padding: 14px !important; }
            .btn-primary { padding: 12px 14px !important; font-size: 14px !important; }
            .social-icons { gap: 16px !important; }
            .social-icon { width: 22px !important; height: 22px !important; }
            .urgent-highlight { padding: 10px !important; }
            .checkout-cta { padding: 14px !important; }
          }
        `
      }} />
      
      <table
        width="100%"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ backgroundColor: "#ffffff", padding: "40px 0" }}
      >
        <tbody>
          <tr>
            <td align="center">
              <table
                className="email-container"
                width={600}
                border={0}
                cellSpacing={0}
                cellPadding={0}
                style={{ 
                  backgroundColor: "#FAFAFA", 
                  borderRadius: "12px", 
                  overflow: "hidden",
                  maxWidth: "600px",
                  margin: "0 auto"
                }}
              >
                <tbody>
                  {/* Header */}
                  <tr>
                    <td 
                      className="header"
                      align="center" 
                      style={{ 
                        backgroundColor: "#1F1746", 
                        padding: "20px",
                        textAlign: "center"
                      }}
                    >
                      <div style={{ textAlign: "center", width: "100%" }}>
                        <img
                          className="logo"
                          src="https://asset.brandfetch.io/idNdb_MPJ2/idFGj2lq6u.png?c=1dxbfHSJFAPEGdCLU4o5B"
                          alt="Logo Trivium"
                          width={120}
                          style={{ 
                            display: "block", 
                            width: "120px", 
                            height: "auto",
                            margin: "0 auto"
                          }}
                        />
                      </div>
                    </td>
                  </tr>

                  {/* Body */}
                  <tr>
                    <td 
                      className="body-content"
                      style={{ 
                        padding: "36px 30px", 
                        color: "#333333"
                      }}
                    >
                      {/* Badge + Title */}
                      <div style={{ textAlign: "center" }}>
                        <span
                          className="badge"
                          style={{
                            backgroundColor: "#fef3c7",
                            color: "#92400e",
                            display: "inline-block",
                            padding: "8px 16px",
                            borderRadius: "999px",
                            fontSize: "13px",
                            fontWeight: 700,
                            marginBottom: "16px"
                          }}
                        >
                          ⏰ Check-out Pendente
                        </span>
                        <h1 
                          className="title"
                          style={{ 
                            fontSize: "24px", 
                            margin: "16px 0 6px", 
                            color: "#111111",
                            lineHeight: "1.3"
                          }}
                        >
                          Olá, {instructorName} 👋
                        </h1>
                        <p 
                          className="subtitle"
                          style={{ 
                            fontSize: "16px", 
                            margin: "0 0 24px", 
                            color: "#555555", 
                            lineHeight: "1.6"
                          }}
                        >
                          Você precisa finalizar o check-out da formação
                          <br />
                          <strong>{courseName}</strong>
                        </p>
                      </div>

                      {/* Destaque Urgente */}
                      <div
                        className="urgent-highlight"
                        style={{
                          background: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
                          border: "2px solid #f59e0b",
                          borderRadius: "12px",
                          padding: "20px",
                          marginBottom: "24px",
                          textAlign: "center"
                        }}
                      >
                        <h2 style={{ 
                          fontSize: "18px", 
                          color: "#92400e", 
                          margin: "0 0 16px",
                          fontWeight: "bold"
                        }}>
                          ⚠️ Ação Necessária
                        </h2>
                        <p style={{ 
                          fontSize: "14px", 
                          color: "#92400e", 
                          margin: 0,
                          lineHeight: "1.5"
                        }}>
                          Por favor, realize o check-out da sessão para finalizar o processo e liberar o certificado dos participantes.
                        </p>
                      </div>

                      {/* Informações da Sessão */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3"
                        }}
                      >
                        📚 Informações da Sessão
                      </h2>
                      <div
                        className="info-box"
                        style={{
                          border: "1px solid #e5e7eb",
                          borderRadius: "10px",
                          padding: "20px",
                          marginBottom: "16px",
                          backgroundColor: "#f9fafb"
                        }}
                      >
                        <h3 style={{ margin: "0 0 4px", fontSize: "16px", color: "#1F1746" }}>{courseName}</h3>
                        <p style={{ margin: "0 0 14px", fontSize: "14px", color: "#6b7280" }}>Sessão ministrada por você</p>
                        <table 
                          width="100%" 
                          cellPadding={0} 
                          cellSpacing={0} 
                          className="info-list"
                          style={{ fontSize: "14px", color: "#111" }}
                        >
                          <tbody>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                🔖 <strong>ID da aula:</strong> {courseId}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                📌 <strong>Sessão:</strong> {session}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                📅 <strong>Data:</strong> {courseDate}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                🕓 <strong>Horário:</strong> {time}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                ⏳ <strong>Duração:</strong> {courseDuration}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                👥 <strong>Participantes:</strong> {participantCount} pessoas
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                🏢 <strong>Empresa:</strong> {companyName}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      {/* Prazo para Check-out */}
                      {checkoutDeadline && (
                        <>
                          <h2 
                            className="section-title"
                            style={{ 
                              fontSize: "18px", 
                              color: "#111", 
                              margin: "24px 0 10px",
                              lineHeight: "1.3"
                            }}
                          >
                            ⏰ Prazo para Check-out
                          </h2>
                          <div
                            className="info-box"
                            style={{
                              background: "#fef2f2",
                              border: "2px solid #fca5a5",
                              borderRadius: "10px",
                              padding: "18px",
                              marginBottom: "20px"
                            }}
                          >
                            <p style={{ 
                              margin: 0, 
                              fontSize: "16px", 
                              color: "#dc2626",
                              lineHeight: "1.6",
                              fontWeight: "bold",
                              textAlign: "center"
                            }}>
                              📅 Prazo limite: {checkoutDeadline}
                            </p>
                          </div>
                        </>
                      )}

                      {/* Call to Action - Check-out */}
                      <div
                        className="checkout-cta"
                        style={{
                          background: "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)",
                          border: "2px solid #3b82f6",
                          borderRadius: "12px",
                          padding: "24px",
                          marginBottom: "24px",
                          textAlign: "center"
                        }}
                      >
                        <h2 style={{ 
                          fontSize: "18px", 
                          color: "#1e40af", 
                          margin: "0 0 16px",
                          fontWeight: "bold"
                        }}>
                          🎯 Realizar Check-out
                        </h2>
                        <p style={{ 
                          fontSize: "14px", 
                          color: "#1e40af", 
                          margin: "0 0 20px",
                          lineHeight: "1.5"
                        }}>
                          Clique no botão abaixo para acessar o sistema e finalizar o check-out da sessão.
                        </p>
                        <a
                          href={checkoutLink}
                          className="btn btn-primary"
                          style={{
                            backgroundColor: "#3b82f6",
                            color: "#ffffff",
                            textDecoration: "none",
                            padding: "14px 28px",
                            borderRadius: "8px",
                            fontSize: "16px",
                            fontWeight: "bold",
                            display: "inline-block",
                            cursor: "pointer",
                            transition: "background-color 0.3s ease",
                            maxWidth: "100%",
                            boxSizing: "border-box"
                          }}
                        >
                          🚀 Fazer Check-out Agora
                        </a>
                      </div>

                      {/* O que fazer no Check-out */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3"
                        }}
                      >
                        📝 O que fazer no Check-out
                      </h2>
                      <div
                        className="info-box"
                        style={{
                          border: "1px solid #e5e7eb",
                          borderRadius: "10px",
                          padding: "20px",
                          marginBottom: "16px"
                        }}
                      >
                        <ul
                          className="list"
                          style={{
                            fontSize: "14px",
                            color: "#4b5563",
                            lineHeight: "1.8",
                            paddingLeft: "20px",
                            margin: 0
                          }}
                        >
                          <li style={{ marginBottom: "8px" }}>✅ <strong>Confirmar presença</strong> dos participantes</li>
                          <li style={{ marginBottom: "8px" }}>📝 <strong>Registrar observações</strong> sobre a sessão</li>
                          <li style={{ marginBottom: "8px" }}>⭐ <strong>Avaliar engajamento</strong> dos participantes</li>
                          <li style={{ marginBottom: "8px" }}>📊 <strong>Reportar feedback</strong> da turma</li>
                          <li style={{ marginBottom: "8px" }}>🎯 <strong>Indicar próximos passos</strong> se aplicável</li>
                          <li style={{ marginBottom: "8px" }}>📜 <strong>Liberar certificados</strong> para os participantes</li>
                        </ul>
                      </div>

                      {/* Importância do Check-out */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3"
                        }}
                      >
                        💡 Por que o Check-out é Importante?
                      </h2>
                      <div
                        className="info-box"
                        style={{
                          background: "#f0fdf4",
                          border: "1px solid #86efac",
                          borderRadius: "10px",
                          padding: "18px",
                          marginBottom: "20px"
                        }}
                      >
                        <ul
                          className="list"
                          style={{
                            fontSize: "14px",
                            color: "#374151",
                            lineHeight: "1.8",
                            paddingLeft: "20px",
                            margin: 0
                          }}
                        >
                          <li style={{ marginBottom: "8px" }}>🎓 <strong>Libera os certificados</strong> para os participantes</li>
                          <li style={{ marginBottom: "8px" }}>📈 <strong>Registra métricas</strong> importantes da sessão</li>
                          <li style={{ marginBottom: "8px" }}>💰 <strong>Confirma o pagamento</strong> da sua aula</li>
                          <li style={{ marginBottom: "8px" }}>📊 <strong>Alimenta relatórios</strong> de qualidade</li>
                          <li style={{ marginBottom: "8px" }}>🔄 <strong>Melhora processos</strong> futuros</li>
                        </ul>
                      </div>

                      {/* Contato do Gestor */}
                      {managerName && managerEmail && (
                        <>
                          <h2 
                            className="section-title"
                            style={{ 
                              fontSize: "18px", 
                              color: "#111", 
                              margin: "24px 0 10px",
                              lineHeight: "1.3"
                            }}
                          >
                            👨‍💼 Contato do Gestor
                          </h2>
                          <div
                            className="info-box"
                            style={{
                              border: "1px solid #e5e7eb",
                              borderRadius: "10px",
                              padding: "18px",
                              marginBottom: "20px"
                            }}
                          >
                            <p style={{ 
                              margin: "0 0 8px", 
                              fontSize: "14px", 
                              color: "#111",
                              lineHeight: "1.6"
                            }}>
                              <strong>👤 Gestor responsável:</strong> {managerName}
                            </p>
                            <p style={{ 
                              margin: 0, 
                              fontSize: "14px", 
                              color: "#111",
                              lineHeight: "1.6"
                            }}>
                              <strong>✉️ Email:</strong> <a href={`mailto:${managerEmail}`} style={{ color: "#3b82f6", textDecoration: "none" }}>{managerEmail}</a>
                            </p>
                          </div>
                        </>
                      )}

                      {/* Contato de suporte */}
                      <div
                        className="contact-box"
                        style={{
                          border: "1px solid #e5e7eb",
                          borderRadius: "10px",
                          padding: "18px",
                          background: "#ffffff",
                          margin: "20px 0",
                          textAlign: "center"
                        }}
                      >
                        <h2 
                          className="contact-title"
                          style={{ 
                            fontSize: "16px", 
                            color: "#111", 
                            margin: "0 0 10px"
                          }}
                        >
                          🤝 Precisa de ajuda? Entre em contato conosco:
                        </h2>
                        <p 
                          className="contact-info"
                          style={{ 
                            margin: 0, 
                            fontSize: "14px", 
                            color: "#374151", 
                            lineHeight: "1.6"
                          }}
                        >
                          ✉️ {supportEmail}
                          <br />📱 {supportPhone}
                        </p>
                      </div>
                    </td>
                  </tr>

                  {/* Footer */}
                  <tr>
                    <EmailFooterV2 variant="clean" showContactInfo={true} />
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
